export default "__VITE_ASSET__D4qi5$Y3__"